<template>
    <div>
      <Head title="Gestão de Funcionários" />
      <div class="shadow_box rounded-lg p-6">
        <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Histórico de Importações</h1>
        
        <data-table
          v-if="loadTable"
          search-label="Pesquisar por nome, e-mail ou CPF"
          v-model:columns="columns"
          :route="'/imports-rows/list/'"
          no-data-label="Nenhum registro encontrado"
          no-result-label="Nenhum registro encontrado"
        >
          


          

          
        </data-table>
      </div>
      
      


    </div>
</template>

<script>
import { computed } from "vue";
import { Head, Link, useForm } from "@inertiajs/inertia-vue3";
import Layout from "@/Shared/Layout/Layout";
import LoadingButton from "@/Shared/Components/LoadingButton";
import ModalDelete from "@/Shared/Modal/ModalDelete";
import ModalEdit from "@/Shared/Modal/ModalEdit";
import Modal from "@/Shared/Modal/Modal";
import DataTable from "@/Shared/Components/DataTable";
import SwitchInput from "@/Shared/Fields/SwitchInput";
import TextInput from "@/Shared/Fields/TextInput";
import EmailInput from "@/Shared/Fields/EmailInput";
import TextareaInput from "@/Shared/Fields/TextareaInput";
import PasswordInput from "@/Shared/Fields/PasswordInput";
import SelectInput from "@/Shared/Fields/SelectInput";
import MaskInput from "@/Shared/Fields/MaskInput";
import VueSelectInput from "@/Shared/Fields/VueSelectInput";
import PhotoInput from "@/Shared/Fields/PhotoInput";
import CepInput from "@/Shared/Fields/CepInput";
import PercentualInput from "@/Shared/Fields/PercentualInput";
import DateInput from "@/Shared/Fields/DateInput";
import MoneyInput from "@/Shared/Fields/MoneyInput";
import PhoneInput from "@/Shared/Fields/PhoneInput";
import FileInput from "@/Shared/Fields/FileInput";
import axios from 'axios';

export default {
  props: {
    
  },
  components: {
    Head,
    LoadingButton,
    ModalDelete,
    ModalEdit,
    Modal,
    DataTable,
    SwitchInput,
    TextInput,
    EmailInput,
    PasswordInput,
    SelectInput,
    MaskInput,
    VueSelectInput,
    TextareaInput,
    PhotoInput,
    CepInput,
    PercentualInput,
    DateInput,
    MoneyInput,
    PhoneInput,
    Link,
    FileInput,
  },
  layout: Layout,
  mounted() {},
  setup() {},
  data() {
    return {
      addresspostcode: "",
      addressstreet: "",
      addressnumber: "",
      addressneighborhood: "",
      addresscity: "",
      addressstate: "",
      addressphone: "",
      addresscomplement: "",
      typesPlans: [],
      imports_employees: [],
      types_plans_options: [],
      value_plan_basic: 0,
      groups: [],
      loadTable: true,
      exportedTable: true,
      columnsExported: [
        {
          uniqid: 'row',
          label: 'Linha',
          field: 'row',
          visible: true,
          
          classes: 'px-4 py-3 border-b text-sm col-name',
          headerClass: 'p-4 text-left',
          

        },
        {
          uniqid: 'result',
          label: 'Resultado',
          field: 'result',
          visible: true,
          
          classes: 'px-4 py-3 border-b text-sm col-name',
          headerClass: 'p-4 text-left',
          
        },        
      ],
      import_id: "",
      columns: [
        {
          uniqid: "import_row",
          label: "Linha",
          field: "row",
          visible: true,
          sortable: true,
          sortOrder: "asc",
          classes: "px-4 py-3 border-b text-sm",
          headerClass: "p-4 text-left",
          format: (val, row) => `${row.row}`,
        },
        {
          uniqid: "import_result",
          label: "Ressultado",
          field: "result",
          visible: true,
          sortable: false,
          sortOrder: "asc",
          classes: "px-4 py-3 border-b text-sm",
          headerClass: "p-4 text-left",
          format: (val, row) => `${row.result}`,
        },
        
      ],
     
    };
  },
  methods: {
    
    async loadImports() {
      await fetch('/employees/importations',
      ).then(res => {
        res.json().then(json => {
          this.imports_employees = json.imports_employees;
        })
      })
    },
  },
};
</script>
